// eslint-disable-next-line import/prefer-default-export
export const HEADER_HEIGHT = 56;
